<div class="modal-header noselect">
  <h2 class="modal-title">Add New Vehicle</h2>
  <button type="button" class="btn-close" (click)="onCancel()" [disabled]="isSubmitting">
    <span class="fa-solid fa-xmark"></span>
  </button>
</div>

<!-- cdkScrollable: lets the owner typeahead's overlay reposition when this
     scrolls. Element scroll events do not reach CDK's document listener. -->
<div class="modal-body" cdkScrollable>
  <form [formGroup]="vehicleForm" (ngSubmit)="onSubmit()">
    <!-- Vehicle Owner Selection (EDIT_ALL_GARAGES permission only) -->
    <div *ngIf="showOwnerSelection" class="form-section">
      <h3 class="section-title noselect">Vehicle Owner</h3>

      <div class="form-group mb-3">
        <label class="checkbox-label noselect">
          <input
            type="checkbox"
            [(ngModel)]="vehicleIsForMe"
            [ngModelOptions]="{standalone: true}"
            (change)="onVehicleIsForMeChange()"
            [disabled]="isSubmitting"
          />
          <span>Vehicle is for me</span>
        </label>
      </div>

      <div *ngIf="!vehicleIsForMe" class="form-group">
        <app-user-search-typeahead
          [placeholder]="'Select vehicle owner...'"
          [selectedUser]="selectedUser"
          (userSelected)="onUserSelected($event)"
        ></app-user-search-typeahead>
      </div>
    </div>

    <!-- Vehicle Information -->
    <div class="form-section">
      <h3 class="section-title noselect">Vehicle Information</h3>

      <app-vehicle-form-fields [form]="vehicleForm"></app-vehicle-form-fields>
    </div>

    <!-- Image Upload Section -->
    <div class="form-section">
      <h3 class="section-title noselect">Vehicle Image (Optional)</h3>

      <div class="image-upload-container">
        <div *ngIf="!imagePreview"
             class="upload-area noselect"
             (drop)="onDrop($event)"
             (dragover)="onDragOver($event)">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24 32V16M24 16L18 22M24 16L30 22M12 32V34C12 36.2 13.8 38 16 38H32C34.2 38 36 36.2 36 34V32"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <p class="upload-text">Drag and drop an image here, or</p>
          <div class="upload-buttons">
            <label for="vehicle-image-upload" class="btn-upload">
              Choose File
            </label>
            <!-- Mobile: open the rear camera directly -->
            <button type="button" class="btn-upload d-sm-none" (click)="cameraInput.click()">
              <span class="fa-solid fa-camera me-1"></span>Take Photo
            </button>
          </div>
          <input
            id="vehicle-image-upload"
            type="file"
            accept="image/*"
            style="display: none;"
            (change)="onImageSelected($event)"
          />
          <input
            #cameraInput
            type="file"
            accept="image/*"
            capture="environment"
            style="display: none;"
            (change)="onImageSelected($event)"
          />
          <p class="upload-hint">Supported formats: JPG, PNG, GIF, WebP (Max 10MB)</p>
        </div>

        <div *ngIf="imagePreview" class="image-preview-container">
          <img [src]="imagePreview" alt="Vehicle preview" class="image-preview" />
          <button type="button" class="btn-remove-image" (click)="removeImage()" [disabled]="isSubmitting">
            <span class="fa-solid fa-xmark"></span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer noselect">
  <button type="button" class="btn btn-secondary" (click)="onCancel()" [disabled]="isSubmitting">
    Cancel
  </button>
  <button type="submit" class="btn btn-primary" (click)="onSubmit()" [disabled]="isSubmitting || !vehicleForm.valid">
    <span *ngIf="!isSubmitting">Add Vehicle</span>
    <span *ngIf="isSubmitting">
      <span class="spinner-small"></span> Adding...
    </span>
  </button>
</div>
